module.exports = __webpack_public_path__ + "media/audios/kid/lesson_5/audio_EdgarExagerado-92d42ceb4bd35e4f485a13f8de2bfe68.m4a";